import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useRootStore } from 'core/hooks/use-root-store';
import { TgJobStore } from './tg-job.store';

const TgJobContext = React.createContext<TgJobStore | null>(null);

export const TgJobProvider = ({ children }: { children: ReactNode }) => {
   const rootStore = useRootStore();
   const { i18n } = useTranslation('global');

   const selectedLanguage = Cookies.get('selectedLanguage') || i18n.language || 'ukr';
   const apiLanguage = selectedLanguage === 'ukr' ? 'uk' : selectedLanguage;

   const [store] = React.useState<TgJobStore>(() => new TgJobStore(rootStore, apiLanguage));

   return <TgJobContext.Provider value={store}>{children}</TgJobContext.Provider>;
};

export const useTgJob = (): TgJobStore => {
   const ctx = React.useContext(TgJobContext);
   if (!ctx) {
      throw new Error('useTgJob must be used inside TgJobProvider');
   }
   return ctx;
};
